/**
 * Helper class for managing click-outside behavior in Vue components.
 */
export default class ClickOutsideHelper {
	/**
	 * The class name that indicates an element should be excluded from click-outside.
	 */
	public static EXCLUDED_FROM_CLICK_OUTSIDE_CLASS = "mia-excluded-from-click-outside";

	/**
	 * Returns an array of HTML elements that should be excluded from click-outside.
	 * This is used with v-click-outside directive to prevent closing modals/dropdowns
	 * when clicking on specific elements.
	 *
	 * @param selectors - Optional array of custom selectors to exclude.
	 * @returns An array of HTML elements that should be excluded from click-outside,
	 * where EXCLUDED_FROM_CLICK_OUTSIDE_CLASS is always INCLUDED.
	 *
	 * @remarks
	 * Prefer using the EXCLUDED_FROM_CLICK_OUTSIDE_CLASS constant when possible instead of passing custom selectors.
	 */
	public static GetExcludedElements(selectors?: string[]): HTMLElement[] {
		const excludedFromClickOutsideClass = `.${ClickOutsideHelper.EXCLUDED_FROM_CLICK_OUTSIDE_CLASS}`;

		return [...(selectors ?? []), excludedFromClickOutsideClass].map((selector) =>
			Array.from(document.querySelectorAll(selector)) as HTMLElement[]).flat();
	}
}
